export default "__VITE_ASSET__DFyUnsRK__"